import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import UUID from 'vue-uuid'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import axios from 'axios'
import VueAxios from 'vue-axios'
import html2canvas from 'html2canvas';
import "@babel/polyfill";
import canvas2image from 'canvas2image';
import vueHeadful from 'vue-headful';
import './style.css' 
Vue.component('vue-headful', vueHeadful);
Vue.use(BootstrapVue)
Vue.use(UUID)
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js